import React from 'react';
import classNames from 'classnames';

class AuthInput extends React.Component {

    static propTypes = {
        placeholder: React.PropTypes.string,
        iconUrl: React.PropTypes.string,
        className: React.PropTypes.string,
        type: React.PropTypes.string,
        value: React.PropTypes.string,
        disabled: React.PropTypes.bool,
        onChange: React.PropTypes.func,
        onKeyPress: React.PropTypes.func,
    };

    static defaultProps = {
        placeholder: "",
        src: null,
        disabled: false
    };

    render() {
        const {
            onChange,
            onKeyPress,
            placeholder,
            iconUrl,
            className,
            type,
            value,
            disabled
        } = this.props;

        return (
            <div className="field-wrap">
                <input
                    ref="input"
                    value={value}
                    className={className}
                    placeholder={placeholder}
                    type={type}
                    disabled={disabled}
                    onChange={onChange}
                    onKeyPress={onKeyPress}
                />
                {
                    iconUrl &&
                    <img
                        className="field__image"
                        src={iconUrl}
                    />
                }
            </div>
        );
    }
}

export default AuthInput;



// WEBPACK FOOTER //
// ./app/components/controls/authInput/AuthInput.jsx